import React, { useState } from 'react'
import { CloudDownloadOutlined } from '@ant-design/icons'
import HandError from './HandError'
import LoadingArea from '../../Loaders/LoadingArea'
import styles from '../Hands.module.scss'
import ControlPanel from './components/ControlPanel'
import Infobar from './components/Infobar'
import HandHeader from './components/HandHeader'
import ActionsList from './components/ActionsList'
import { useComponentLocale } from '../../hooks/useComponentLocale'
import { Button, Input, Modal, notification } from 'antd'
import { useSelector } from 'react-redux'
import { selectHand } from '../../Redux/selectors/selectors'
import { CopyToClipboard } from 'react-copy-to-clipboard/lib/Component'

const { TextArea } = Input

const openNotification = (messageLocale, descriptionLocale) => {
	notification.info({
		message: messageLocale,
		description: descriptionLocale,
		placement: 'bottomLeft',
		duration: 3,
	})
}

function InstaHandResult({ handTab, displayHH, handData, isLoading, onRemoveSingleHand, filter, isTopBar }) {
	const [isRangeMode, setIsRangeMode] = useState(false)
	const [isHideOOPHand, setIsHideOOPHand] = useState(true)
	const [handVisible, setHandVisible] = useState(false)

	const getLocale = useComponentLocale()
	const gtoLocale = getLocale({ component: 'hands', section: 'GTO_analysis' })
	const handHistoryLocale = getLocale({ component: 'hand_result', section: 'hand_history' })
	const messageLocale = getLocale({ component: 'common', section: 'copied_successfully' })
	const descriptionLocal = 'Hand history text copied'

	const { singleHandResponse } = useSelector(selectHand)

	const textAreaValue = singleHandResponse ? singleHandResponse.rawHand : ''

	const toggleRangeMode = (e) => setIsRangeMode(e.target.checked)

	const toggleHideOOPHand = (e) => setIsHideOOPHand(e.target.checked)

	const onOpenRaw = () => setHandVisible(true)

	const onModalClose = () => setHandVisible(false)

	const renderHandRes = () => {
		let handRes = (
			<div className={styles.stubArea}>
				<p className={styles.stubText}>
					<div>
						<CloudDownloadOutlined style={{ fontSize: '80px' }} />
					</div>
					{gtoLocale}
				</p>
			</div>
		)

		if (isLoading) {
			handRes = <LoadingArea />
		} else if (handData) {
			if (handData.error !== null) {
				if (handData.error === 0 || handData.error === 10) {
					handRes = <HandError errorCode={handData.error} />
				} else {
					handRes = (
						<div className={styles.handInfoPanel}>
							<Infobar handData={handData} />
							<HandError errorCode={handData.error} />
						</div>
					)
				}
			} else {
				handRes = (
					<div className={styles.handInfoPanel}>
						<ControlPanel
							onRemoveSingleHand={onRemoveSingleHand}
							isRangeMode={isRangeMode}
							isHideOOPHand={isHideOOPHand}
							handData={handData}
							displayHH={displayHH}
							onOpenRaw={onOpenRaw}
							source={filter?.source}
							heroPerspective={filter?.is_hero}
							toggleRangeMode={toggleRangeMode}
							toggleHideOOPHand={toggleHideOOPHand}
						/>

						<HandHeader
							handData={handData}
							isHideOOPHand={isHideOOPHand}
							filter={filter}
							isTopBar={isTopBar}
							handTab={handTab}
						/>

						<Infobar handData={handData} />

						<ActionsList
							handData={handData}
							isRangeMode={isRangeMode}
							isHideOOPHand={isHideOOPHand}
							handTab={handTab}
							filter={filter}
						/>
					</div>
				)
			}
		}

		return handRes
	}

	return (
		<>
			{renderHandRes()}

			<Modal
				title={handHistoryLocale}
				centered
				footer={
					<div style={{ display: 'flex', justifyContent: 'space-between' }}>
						<CopyToClipboard text={textAreaValue}>
							<Button key='1' onClick={() => openNotification(messageLocale, descriptionLocal)}>
								Copy
							</Button>
						</CopyToClipboard>
						<span>
							<Button key='2' disabled>
								Cancel
							</Button>
							<Button key='3' type='primary' onClick={onModalClose}>
								OK
							</Button>
						</span>
					</div>
				}
				open={handVisible}
				destroyOnClose
				onCancel={onModalClose}
			>
				<TextArea style={{ fontFamily: 'monospace' }} rows={20} value={textAreaValue} />
			</Modal>
		</>
	)
}

export default InstaHandResult
